import {
  GetSaleRes_LinkedChildSales as LinkedChildSales,
  GetSaleRes_ReturnedInSales as ReturnedInSales,
} from "gen/api/sale/service_pb"
import { Sale } from "gen/txn/models_pb"

import { SaleLink } from "../types/SaleForm.types"

export function convertSaleToSaleLink(sale: Sale): SaleLink {
  if (!sale.id) {
    throw new Error("Sale does not have an ID")
  }
  return {
    id: sale.id,
    type: sale.type,
    identifier: sale.identifier,
    saleStatus: sale.status,
  }
}

export function convertSalesToSaleLinks(
  salesMap: Record<string, Sale>
): Record<string, SaleLink> {
  const saleLinksMap: Record<string, SaleLink> = {}

  for (const [key, sale] of Object.entries(salesMap)) {
    if (sale.id) {
      saleLinksMap[key] = convertSaleToSaleLink(sale)
    }
  }
  return saleLinksMap
}

export function convertReturnedInSalesToSaleLinks(
  salesMap: Record<string, ReturnedInSales>
): Record<string, SaleLink[]> {
  const saleLinksMap: Record<string, SaleLink[]> = {}
  for (const [key, val] of Object.entries(salesMap)) {
    const saleLinks: SaleLink[] = []
    for (const sale of val.sales) {
      if (sale.id) {
        saleLinks.push({
          id: sale.id,
          type: sale.type,
          identifier: sale.identifier,
          saleStatus: sale.status,
        })
      }
    }
    saleLinksMap[key] = saleLinks
  }
  return saleLinksMap
}

export function convertLinkedChildSalesToSaleLinks(
  childSalesMap: Record<string, LinkedChildSales>
): Record<string, SaleLink[]> {
  const saleLinksMap: Record<string, SaleLink[]> = {}
  for (const [key, val] of Object.entries(childSalesMap)) {
    const saleLinks: SaleLink[] = []
    for (const sale of val.sales) {
      if (sale.id) {
        saleLinks.push({
          id: sale.id,
          type: sale.type,
          identifier: sale.identifier,
          saleStatus: sale.status,
        })
      }
    }
    saleLinksMap[key] = saleLinks
  }
  return saleLinksMap
}
